"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGN_UP_COPY = void 0;
exports.SIGN_UP_COPY = {
    PARTIAL_AGREEMENT: 'I agree to the ',
    SIGN_UP: 'Sign Up',
    SIGN_UP_FOR_AROVY: 'Sign Up for Arovy'
};
//# sourceMappingURL=SIGN_UP_COPY.js.map